"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcSpaceHorizontal = void 0;
const Toolbar_1 = require("./..");
const View_1 = require("../../View");
const calcSpaceHorizontal = (view, buildIn) => {
    return view === Toolbar_1.TOOLBAR_VIEW_TYPE.spotted || buildIn ? View_1.INDENT.s : View_1.INDENT.none;
};
exports.calcSpaceHorizontal = calcSpaceHorizontal;
//# sourceMappingURL=calcSpaceHorizontal.js.map